import { Component, EventEmitter, Injector, OnInit, Output, Input } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { AbpValidationError } from '@shared/components/validation/abp-validation.api';
import { EmailAlternativoDto, EnderecoDto, EnumDto, EnumServiceProxy, GerarFichaPacienteDto, PacienteDto, PacienteServiceProxy, UpdateEnderecoDto, UpdatePacienteDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as printJS from 'print-js';
import { finalize } from 'rxjs/operators';
import { Guid } from '@shared/model/guid.model';
import { DataNascimentoMinima } from 'shared/model/data-nascimento-minima';
import { BuscaCepService } from '@shared/services/busca-cep.service';
import { AppSessionService } from '@shared/session/app-session.service';
import { RolesNames } from '@shared/constant/roles-names';
import { StringUtils } from '@shared/helpers/StringUtils';

@Component({
  selector: 'app-edit-paciente-dialog',
  templateUrl: './edit-paciente-dialog.component.html',
  styleUrls: ['./edit-paciente-dialog.component.scss']
})

export class EditPacienteDialogComponent
  extends AppComponentBase
  implements OnInit {
  saving = false;
  showBotaoImprimir = true;
  foto: string;
  dataNascimento: string = "";
  avatar: string;
  showPassword = true;
  listaSexo: EnumDto[] = [];
  listaTipoSanguineo: EnumDto[] = [];
  listaCorEtnia: EnumDto[] = [];
  listaEstadoCivil: EnumDto[] = [];
  email: string;
  emailAlt: string = "";
  cns: string;
  cadEmail = false;
  erro = false;
  editCpf: boolean = true;
  desabilitarCamposEndereco: boolean = true;
  enderecoPreenchido: boolean = false;
  private emailGenerico: string;

  guid: Guid = new Guid();
  private dataMinimaNascimento: DataNascimentoMinima = new DataNascimentoMinima();

  passwordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey:
        "PasswordsMustBeAtLeast8CharactersContainCharactersNumber",
    },
  ];

  newCnsValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey: "CnsValidation",
    },
  ];

  @Output() onSave = new EventEmitter<any>();
  @Input() paciente: UpdatePacienteDto;

  constructor(
    injector: Injector,
    private _pacienteService: PacienteServiceProxy,
    private _enumService: EnumServiceProxy,
    private _buscaCepService: BuscaCepService,
    private _sessionService: AppSessionService,
    public bsModalRef: BsModalRef,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.paciente.email?.includes('sh1ft')) {
      this.emailGenerico = this.paciente.email;
      this.paciente.email = '';
    }
    this.cns = this.paciente.cns;
    this._getEndereco();
    this.obterListaSexo();
    this.obterListaCorEtnia();
    this.obterListaTipoSanguineo();
    this.obterListaEstadoCivil();
    this.validarNivelUsuario();
    if (this.paciente.dataNascimento)
      this.dataNascimento = moment(this.paciente.dataNascimento).format("DDMMYYYY");
    abp.ui.setBusy();
    this._pacienteService
      .getAvatar(this.paciente.avatar).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((resultado) => {
        this.paciente.avatar = resultado;
      });
    abp.ui.setBusy();
    if (this.paciente.responsavelLegalId != null) {
      this._pacienteService.getAllEmailsAlternativos(this.paciente.responsavelLegalId).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe((emails) => {
        this.paciente.emailAlternativo = emails;
      });
    } else {
      this._pacienteService.getAllEmailsAlternativos(this.paciente.id).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe((emails) => {
        this.paciente.emailAlternativo = emails;
      });
    }

  }

  validarNivelUsuario() {
    if (this._sessionService.user.tipoUsuario == RolesNames.Outros) this.editCpf = true;
    else this.editCpf = false;
  }

  dataNascimentoValida($event) {
    if (this.dataMinimaNascimento.dataNascimentoValida($event)) {
      return;
    }
    else {
      setTimeout(() => {
        this.notify.error(this.l("Data de nascimento inválida!"));
        document.getElementById("data-nascimento").focus();
        this.inputWarningClass("data-nascimento");
      }, 100);
    }
  }

  onSelectDate($event) {
    if ($event && $event.length == 8) {
      if (this.dataMinimaNascimento.dataNascimentoValida($event))
        this.paciente.dataNascimento = moment($event, "DDMMYYYY");
      else {
        setTimeout(() => {
          this.notify.error(this.l("Data de nascimento inválida!"));
          document.getElementById("data-nascimento").focus();
          this.inputWarningClass("data-nascimento");
        }, 100);
      }
    } else {
      this.paciente.dataNascimento = undefined;
    }
  }

  save(imprimir: boolean = false): void {
    if (this.erro) {
      this.notify.error("CNS ou e-mail já cadastrados!");
    } else {
      if (!this.paciente.enderecoAtualizado.cep) {
        this.paciente.enderecoAtualizado = null;
        this.paciente.enderecoAtualizadoId = null;
      }
      if (StringUtils.isNullOrEmpty(this.paciente.email)) {
        this.paciente.email = this.emailGenerico;
      }

      this.saving = true;
      this._pacienteService
        .update(this.paciente)
        .pipe(
          finalize(() => {
            if (!imprimir) {
              this.saving = false;
            }
          })
        ).subscribe((paciente) => {
          this.notify.info(this.l("SavedSuccessfully"));
          if (!imprimir) {
            this.fecharAposSalvar();
          } else {
            this.imprimir(paciente);
          }
          this.saving = false;
        });
    }
  }

  onSelectCep($event) {
    this.desabilitarCamposEndereco = true;
    this.enderecoPreenchido = true;
    this.paciente.enderecoAtualizado.cep = $event;
    if ($event.length == 8) {
      const sub = this._buscaCepService.getCep($event).subscribe((x) => {
        if (x["erro"]) {
          abp.message.error("CEP inválido");
        } else {
          this.paciente.enderecoAtualizado.logradouro = x["logradouro"];
          this.paciente.enderecoAtualizado.cidade = x["localidade"];
          this.paciente.enderecoAtualizado.bairro = x["bairro"];
          this.paciente.enderecoAtualizado.estado = x["uf"].toUpperCase();
          this.paciente.enderecoAtualizado.complemento = x["complemento"];
          this.paciente.enderecoAtualizado.codigoIbge = x["ibge"];
          this.paciente.enderecoAtualizado.numero = "";
          this.desabilitarCamposEndereco = false;
        }
      });
    }
  }

  private fecharAposSalvar() {
    this.bsModalRef.hide();
    this.onSave.emit();
  }

  imprimir(paciente: PacienteDto): void {
    let grafico = new GerarFichaPacienteDto();
    grafico.pacienteId = paciente.id;
    this._pacienteService
      .gerarPdfFichaPaciente(grafico)
      .pipe(
        finalize(() => {
          this.saving = false;
        })
      )
      .subscribe((base64) => {
        printJS({ printable: base64, type: 'pdf', base64: true });
        this.fecharAposSalvar();
      });
  }

  cnsOnBlur() {
    if (this.paciente.cns == this.cns) return;

    abp.ui.setBusy();
    this._pacienteService
      .cnsExistsOrInvalid(this.cns, null)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((resultado) => {
        if (resultado) {
          this.erro = true;
          this.notify.error(this.l("CnsExistsOrInvalid"));
          this.inputWarningClass("cns");
        } else {
          this.paciente.cns = this.cns;
          this.inputWarningClass("cns", false);
          this.erro = false;
        }
      });
  }

  private obterListaSexo() {
    this._enumService.getByEnumName('SexoEnum').subscribe(x => {
      this.listaSexo = x.items;
    })
  }

  private inputWarningClass(elementId: string, setInvalid: boolean = true) {
    document.getElementById(elementId).classList.add("is-invalid");

    if (!setInvalid)
      document.getElementById(elementId).classList.remove("is-invalid");
  }

  handleFileInput(files: FileList) {
    const file = files.item(0);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.paciente.avatar = reader.result.toString();
      this.paciente.atualizarAvatar = true;
      this.paciente.nomeAvatar = file.name;

    };
  }

  removerAvatar() {
    this.paciente.avatar = undefined;
    this.paciente.atualizarAvatar = true;
    this.paciente.nomeAvatar = undefined;
  }

  isDependente(): boolean {
    if (!this.paciente.responsavelLegalId)
      return false;
    return !this.guid.isGuidEmpty(this.paciente.responsavelLegalId);
  }

  addEmailLista(email: string) {
    if (email == this.paciente.email) {
      abp.notify.error("Esse e-mail alternativo não pode ser igual ao e-mail principal!");
      return;
    }
    for (let emailAlt of this.paciente.emailAlternativo) {
      if (emailAlt.email == email) {
        abp.notify.error("Esse e-mail já está cadastrado!");
        return;
      }
    }
    if (email != "") {
      if (!this.validarEmail(email)) {
        abp.notify.error("E-mail inválido!");
        return;
      }
      let el = new EmailAlternativoDto();
      el.email = email.trim();
      this.paciente.emailAlternativo.unshift(el);
      this.emailAlt = "";
    }
  }

  removerLista(email: EmailAlternativoDto) {
    abp.message.confirm(`Deseja realmente excluir o e-mail ${email.email} da sua lista?`, 'Confirmação', (result) => {
      if (result) {
        this._pacienteService.deletarEmailAlternativo(email)
          .pipe(finalize(() => {
          })).subscribe((emails) => {
            this.paciente.emailAlternativo = this.paciente.emailAlternativo.filter(item => item != email);
            this.notify.success("E-mail removido com sucesso!");
          })
      }
    });
  }

  validarEmail(email: string): boolean {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  isCad() {
    this.cadEmail = true;
  }

  private _getEndereco() {
    abp.ui.setBusy();
    this._pacienteService.getEndereco(this.paciente.id).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((endereco: EnderecoDto) => {
      this.paciente.enderecoAtualizado = UpdateEnderecoDto.fromJS(endereco);
      this.paciente.enderecoAtualizadoId = endereco.id;
    });
  }

  private obterListaTipoSanguineo() {
    this._enumService.getByEnumName('TipoSanguineoEnum').subscribe(x => {
      this.listaTipoSanguineo = x.items;
    });
  }

  private obterListaEstadoCivil() {
    this._enumService.getByEnumName('EstadoCivilEnum').subscribe(x => {
      this.listaEstadoCivil = x.items;
    });
  }

  private obterListaCorEtnia() {
    this._enumService.getByEnumName('CorEtniaEnum').subscribe(x => {
      this.listaCorEtnia = x.items;
    });
  }
}

